module.exports = __webpack_public_path__ + "img/appstore-badge.075b00b0.png";